import { Ref, useImperativeHandle, useRef } from 'react';
import { UploadRef } from '../upload';
import { PickerRef, UseTriggerResult } from './types';

/**
 * 手动触发文件选择
 * @param ref
 * @returns
 */
export function useTrigger(ref: Ref<PickerRef>): UseTriggerResult {
  const uploadRef = useRef<UploadRef>(null);

  useImperativeHandle(ref, () => ({
    open(): void {
      uploadRef.current?.open();
    }
  }));

  return { uploadRef };
}
